const getStyle = (el, styleProp) => {
  let y = null;

  if (window.getComputedStyle) {
    y = document.defaultView.getComputedStyle(el, null).getPropertyValue(styleProp);
  } else if (el.currentStyle) {
    y = el.currentStyle[styleProp];
  }

  return y;
};

export default getStyle;
